import React from 'react'
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
const SettingsForm = () => {
    return (
        <>
            <div className="_nft_settings_profile_form_wrap">
                <form className="_nft_settings_profile_form">
                    <div className="mb-4">
                        <label htmlFor="exampleInputName" className="form-label _nft_settings_profile_form_label">User
                            Name</label>
                        <input type="text" className="form-control _nft_settings_profile_form_inpt" id="exampleInputName" aria-describedby="nameHelp" placeholder="jubed001" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="exampleInputName1" className="form-label _nft_settings_profile_form_label">Name</label>
                        <input type="text" className="form-control _nft_settings_profile_form_inpt" id="exampleInputName1" aria-describedby="nameHelp" placeholder="Jubed Ahmed" />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="exampleInputName1" className="form-label _nft_settings_profile_form_label">Your
                            Bio</label>
                        <Editor
                            toolbarClassName="toolbarClassName"
                            wrapperClassName="wrapperClassName"
                            editorClassName="edit"
                        />
                    </div>
                    <div className="mb-4">
                        <label htmlFor="exampleInputEmail1" className="form-label _nft_settings_profile_form_label">Email Address</label>
                        <input type="email" className="form-control _nft_settings_profile_form_inpt" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="uihutofficial@gmail.com" />
                    </div>
                    <div className="mb-4">
                        <div className="_nft_settings_profile_verify">
                            <h6 className="_nft_settings_profile_form_label">Verification</h6>
                            <div className="_nft_settings_profile_verify_cont_btns">
                                <p className="_nft_settings_profile_verify_cont">Proceed with verifacation
                                    process to get more visibility and gain trust on All Blocks
                                    Marketplace. Please allow up to several weeks for the
                                    process.
                                </p>
                                <button className="_nft_settings_profile_verify_cont_btn">
                                    Get verifications
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="mb-4">
                        <div className="_nft_settings_profile_verify">
                            <h6 className="_nft_settings_profile_form_label">Social Connection</h6>
                            <p className="_nft_settings_profile_verify_cont">Help Collectors verify account by
                                connecting Twitter</p>
                            <div className="_nft_settings_profile_connect_cont_btns">
                                <p className="_nft_settings_profile_connect_cont">
                                    <span className="_nft_settings_profile_connect_cont_ic">
                                        <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32">
                                            <path fill="#808191" d="M26.66 8.917a5.733 5.733 0 0 0 2.516-3.165 11.453 11.453 0 0 1-3.633 1.388 5.733 5.733 0 0 0-9.755 5.22A16.245 16.245 0 0 1 3.996 6.381a5.733 5.733 0 0 0 1.77 7.64 5.702 5.702 0 0 1-2.59-.717v.072a5.725 5.725 0 0 0 4.59 5.61 5.733 5.733 0 0 1-2.583.1 5.733 5.733 0 0 0 5.345 3.973 11.48 11.48 0 0 1-7.107 2.449c-.457 0-.913-.027-1.366-.079A16.198 16.198 0 0 0 10.827 28a16.17 16.17 0 0 0 16.28-16.281c0-.248-.006-.495-.018-.74a11.625 11.625 0 0 0 2.856-2.963 11.44 11.44 0 0 1-3.285.901Z" />
                                        </svg>
                                    </span>
                                    Twitter</p>
                                <button className="_nft_settings_profile_connect_cont_btn">
                                    Connect
                                </button>
                            </div>
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary _nft_settings_profile_form_btn">Update
                        Profile</button>
                </form>
            </div>
            <div className="_nft_settings_profile_form01_wrap">
                <h3 className="_nft_settings_profile_form01_txt">Password</h3>
                <form className="_nft_settings_profile_password_form">
                    <div className="mb-4">
                        <label htmlFor="exampleInputPassword" className="form-label _nft_settings_profile_form_label">Old Password</label>
                        <input type="password" className="form-control _nft_settings_profile_form_inpt" id="exampleInputPassword" aria-describedby="passwordHelp" placeholder="Jubed Ahmed" />
                    </div>
                    <div className="_nft_settings_profile_password_form_bottm_inpt mb-4">
                        <div className="_nft_settings_profile_password_form_bottm_inpt01">
                            <label htmlFor="exampleInputNewPassword" className="form-label _nft_settings_profile_form_label">New Password</label>
                            <input type="password" className="form-control _nft_settings_profile_form_inpt" id="exampleInputNewPassword" aria-describedby="NewpasswordHelp" placeholder="Jubed Ahmed" />
                        </div>
                        <div className="_nft_settings_profile_password_form_bottm_inpt01">
                            <label htmlFor="exampleInputConfirmPassword" className="form-label _nft_settings_profile_form_label">Confirm New Password</label>
                            <input type="password" className="form-control _nft_settings_profile_form_inpt" id="exampleInputConfirmPassword" aria-describedby="ConfirmpasswordHelp" placeholder="Jubed Ahmed" />
                        </div>
                    </div>
                    <button type="submit" className="btn btn-primary _nft_settings_profile_form_btn">Update
                        Password</button>
                </form>
            </div>
        </>
    )
}

export default SettingsForm